import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from './button.component';
import { DssButtonModule } from '@dss/components/button';
import { TrackingModule } from '../../../../shared/directives/tracking.module';
@NgModule({
  declarations: [ButtonComponent],
  imports: [
    CommonModule,
    DssButtonModule,
    TrackingModule
  ],
  exports:[ButtonComponent]
})
export class ButtonModule { }
